import { css } from 'lit';

import { narrow, touchOrNarrow } from '../media.js';

export const planeDemoBarStyles = css`
  /* Chart under correction: hazard hatching, so a demo is never mistaken for a fleet. */
  :host {
    display: block;
    background:
      repeating-linear-gradient(-45deg, transparent 0 10px, var(--demo-band-hatch) 10px 20px),
      var(--demo-band);
    color: var(--demo-band-text);
    font-size: var(--font-size-md);
    /* The first band of the page: under the status bar of the installed app. */
    padding-top: var(--safe-top);
  }

  strong {
    font-family: var(--font-mono);
    font-size: var(--font-size-xs);
    letter-spacing: var(--tracking-widest);
    text-transform: uppercase;
    padding: var(--chip-padding);
    background: var(--demo-band-text);
    color: var(--demo-band);
    border-radius: var(--radius);
  }

  .bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2) var(--space-4);
    max-width: var(--page-width);
    margin: 0 auto;
    padding: var(--space-1) calc(var(--space-5) + var(--safe-right)) var(--space-1) calc(var(--space-5) + var(--safe-left));
  }

  .controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2) var(--space-4);
    margin-left: auto;
  }

  label {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
  }

  select,
  button {
    font: inherit;
    font-size: var(--font-size-sm);
    padding: var(--chip-padding);
    border-radius: var(--radius);
    border: var(--border-width) solid color-mix(in srgb, currentColor 45%, transparent);
    background: var(--demo-band-control);
    color: inherit;
    cursor: pointer;
  }

  /* No zoom on focus in Safari on iOS (formStyles). */
  @media ${touchOrNarrow} {
    select {
      font-size: var(--font-size-touch-field);
    }

    select,
    button {
      min-height: var(--touch-target-compact);
    }
  }

  option {
    color: initial;
  }

  .servers {
    display: inline-flex;
    gap: var(--space-2);
  }

  .toggle {
    display: none;
  }

  /* On a phone the band would take a fifth of the screen: one line, the controls behind a
     toggle. */
  @media ${narrow} {
    .bar {
      flex-wrap: wrap;
    }

    .note {
      display: none;
    }

    .toggle {
      display: inline-flex;
      margin-left: auto;
    }

    .controls {
      display: none;
      flex-basis: 100%;
      margin: var(--space-1) 0 var(--space-2);
    }

    .controls.open {
      display: flex;
    }
  }
`;
